// extracted by mini-css-extract-plugin
export default {"Title":"ProgramConfiguration_Title__fW38I","Row":"ProgramConfiguration_Row__jbSR9","CoverRecommendation":"ProgramConfiguration_CoverRecommendation__HX5NI"};